// Swiper is imported already

if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: true,
        showClass: false,
        mainClass: 'image-zoom',
        hasZoom: false,
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
      this.quantityInput = this.querySelector('quantity-calculator');
      this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
      this.quantityInputElement?.addEventListener('change', () => {
        this.handleQuantityInput();
      });
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput() {
      this.productFormQuantity.value = this.quantityInputElement.value;
    }
  }
  customElements.define('product-info', ProductInfo);
}
class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.initElements();
    this.bindEvents();
    this.initObserver();

    this.addEventListener('click', this.handleClick);
  }

  initElements() {
    this.addToCart = this.querySelector('[data-sticky-add-to-cart]');
    this.productForm = document.querySelector('product-info product-form');
    this.productInfo = document.querySelector('product-info');
    this.footer = document.querySelector('[data-main-footer]');
    this.checkForCustomerService();
  }

  checkForCustomerService() {
    const customerService = document.querySelector('.sticky-customer-service');
    if (customerService) {
      const offset = window.innerWidth < 768 ? 25 : 33;
      // Added stylesheet trough JS because of a custom 'bottom' value which Tailwind wouldn't compile after
      var styles = `
          .sticky-atc .sticky-customer-service modal-window {
              bottom: ${this.clientHeight + offset}px !important;
          }


        `;

      var styleSheet = document.createElement('style');
      styleSheet.textContent = styles;
      document.head.appendChild(styleSheet);
    }
  }

  bindEvents() {
    if (this.addToCart) {
      this.addToCart.addEventListener('click', (e) => {
        this.productForm.onSubmitHandler(e);
      });
    }
  }

  initObserver() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this));

      if (this.productInfo instanceof Element) {
        this.observer.observe(this.productInfo);
      }

      if (this.footer instanceof Element) {
        this.observer.observe(this.footer);
      }
    }
  }

  handleIntersection(entries) {
    const body = document.querySelector('body');

    entries.forEach((entry) => {
      if (entry.target === this.footer) {
        entry.isIntersecting
          ? this.classList.add('hidden-by-footer')
          : this.classList.remove('hidden-by-footer');
      } else {
        !entry.isIntersecting
          ? (this.classList.add('!translate-y-0'), body.classList.add('sticky-atc'))
          : (this.classList.remove('!translate-y-0'), body.classList.remove('sticky-atc'));
      }
    });
  }

  handleClick() {
    this.classList.contains('hidden-by-footer') && this.classList.remove('hidden-by-footer');
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
